(function () {
  'use strict';
  var data = window.KitCartLock;
  if (!data || !data.items || !data.items.length) return;
  var map = {};
  data.items.forEach(function (i) { map[i.key] = i.kit; });

  function apply() {
    Object.keys(map).forEach(function (key) {
      var row = document.getElementById('CartItem-' + key);
      if (!row || row.dataset.kitLocked) return;
      row.dataset.kitLocked = '1';
      row.classList.add('is-kit-item');
      row.querySelectorAll('input[name="updates[]"]').forEach(function (inp) { inp.readOnly = true; inp.tabIndex = -1; });
      row.querySelectorAll('.quantity__buttons').forEach(function (b) { b.style.display = 'none'; });
      var rm = row.querySelector('a[is="cart-remove-button"], a[data-index]');
      if (rm) {
        var a = document.createElement('a');
        a.href = '#';
        a.className = rm.className;
        a.textContent = 'Remove kit';
        a.setAttribute('data-kit-remove', map[key]);
        rm.parentNode.replaceChild(a, rm);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-kit-remove]');
    if (!a) return;
    e.preventDefault();
    var kit = a.getAttribute('data-kit-remove');
    a.textContent = 'Removing...';
    fetch(data.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._kit_id === kit) updates[it.key] = 0;
        });
        return fetch(data.routes.update, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  });

  apply();
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
})();
